"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentEventRecorder = void 0;
const analytics_next_1 = require("@segment/analytics-next");
const LinkTypes_1 = require("../../Types/LinkTypes");
const InvalidEducatorLinkType_1 = __importDefault(require("../../Errors/InvalidEducatorLinkType"));
const InvalidEducatorId_1 = __importDefault(require("../../Errors/InvalidEducatorId"));
const NO_CONTEXT = {
    type: 'none',
};
class SegmentEventRecorder {
    constructor({ apiKey, recordedOn }) {
        this.apiKey = apiKey;
        this.recordedOn = recordedOn;
    }
    educatorProfileView(educatorId, name, url, recordedAt) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!educatorId || typeof educatorId !== 'string') {
                throw new Error('Missing Educator Id');
            }
            return this.pageView(name, url, {
                type: 'educator',
                educatorId: educatorId,
            }, recordedAt);
        });
    }
    coursePageView(educatorId, courseId, name, url, recordedAt) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!educatorId || typeof educatorId !== 'string') {
                throw new Error('Missing Educator Id');
            }
            if (!courseId || typeof courseId !== 'string') {
                throw new Error('Missing Course Id');
            }
            return this.pageView(name, url, {
                type: 'course',
                educatorId,
                courseId,
            }, recordedAt);
        });
    }
    pageView(name, url, context, recordedAt) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!name || typeof name !== 'string') {
                throw new Error('Missing Page Name');
            }
            if (!url || !(url instanceof URL)) {
                throw new Error('Missing URL');
            }
            if (!this.analytics) {
                return;
            }
            yield this.analytics.page(name, Object.assign(Object.assign({}, context), { url: url.toString(), recordedOn: this.recordedOn, recordedAt }));
        });
    }
    socialLinkRedirect(href, linkType, name, url, educatorId, recordedAt) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!LinkTypes_1.linkTypes.includes(linkType)) {
                throw new InvalidEducatorLinkType_1.default();
            }
            if (!educatorId || typeof educatorId !== 'string') {
                throw new InvalidEducatorId_1.default();
            }
            const source = {
                name,
                url: url.toString(),
            };
            const context = {
                type: 'social_link',
                educatorId: educatorId,
                linkType: linkType,
            };
            yield this.externalRedirect(href, source, context, recordedAt);
        });
    }
    externalRedirect(href_1, source_1) {
        return __awaiter(this, arguments, void 0, function* (href, source, context = NO_CONTEXT, recordedAt) {
            if (!href || !(href instanceof URL)) {
                throw new Error('Missing Href');
            }
            if (!source) {
                throw new Error('Missing Source');
            }
            if (!this.analytics) {
                return;
            }
            yield this.analytics.track('External Redirect', Object.assign(Object.assign({}, context), { href: href.toString(), source, recordedOn: this.recordedOn, recordedAt }));
        });
    }
    event(name, context, recordedAt) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!name || typeof name !== 'string') {
                throw new Error('Missing Event Name');
            }
            if (!this.analytics) {
                return;
            }
            yield this.analytics.track(name, Object.assign(Object.assign({}, context), { recordedOn: this.recordedOn, recordedAt }));
        });
    }
    identifyUser(user) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!user || !user.authenticated || !user.id) {
                throw new Error('Missing User Id');
            }
            if (!this.analytics) {
                this.analytics = analytics_next_1.AnalyticsBrowser.load({
                    writeKey: this.apiKey,
                });
            }
            yield this.analytics.identify(user.id, {
                firstName: user.firstName,
                lastName: user.lastName,
                email: user.email,
                emailConfirmed: user.emailConfirmed,
                isAdmin: user.educators.length > 0,
                recordedOn: this.recordedOn,
            });
        });
    }
    educatorCreated(createdBy, educatorId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.analytics) {
                return;
            }
            yield this.analytics.identify(createdBy.id, {
                firstName: createdBy.firstName,
                lastName: createdBy.lastName,
                email: createdBy.email,
                emailConfirmed: createdBy.emailConfirmed,
                isAdmin: true,
                recordedOn: this.recordedOn,
                firstUser: true,
                $groups: {
                    segment_group: educatorId,
                },
            });
        });
    }
}
exports.SegmentEventRecorder = SegmentEventRecorder;
